//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 转款单列表申请
const transferList = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/transfer/list.vue')));
//转款单新建、修改
const transferAdd = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/transfer/add.vue')));
const transferEdit = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/transfer/edit.vue')));

const router = {
  path: '/transfer',
  component: index,
  children: [
    {
      path: 'list',
      name: 'transferList',
      component: transferList,
      meta: {
        keepAlive: true,
        title: '转款单查询',
      },
    },
    {
      path: 'transferAdd',
      name: 'transferAdd',
      component: transferAdd,
      meta: {
        keepAlive: true,
        title: '转款单创建',
      },
    },
    {
      path: 'transferEdit',
      name: 'transferEdit',
      component: transferEdit,
      meta: {
        keepAlive: true,
        title: '转款单编辑',
      },
    },
  ],
};

export default router;
